import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CapriLogo from "../../assets/capri-logo.webp";
import "./index.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header
      className={`header ${
        isLandingPage ? "landing-header" : "default-header"
      }`}
    >
      <nav className="navbar">
        <div className="hamburger" onClick={toggleMenu}>
          ☰
        </div>
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about-us" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/resilient-fund" onClick={closeMenu}>
              Capri Stressed Assets Fund
            </Link>
          </li>
          <li>
            <Link to="/teams" onClick={closeMenu}>
              Teams
            </Link>
          </li>
          <li>
            <Link to="/portfolio" onClick={closeMenu}>
              Our Portfolio
            </Link>
          </li>
          <li>
            <Link to="/news-media" onClick={closeMenu}>
              News and Media
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={closeMenu}>
              Get In Touch
            </Link>
          </li>
        </ul>
        <div className="right-section">
          <img src={CapriLogo} alt="Capri Logo" />
        </div>
      </nav>
    </header>
  );
};

export default Header;
